<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/account' }">账户</el-breadcrumb-item>
                <el-breadcrumb-item>账户{{type == '1' ? '编辑' : '新增',}}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submitDetailsData('ruleDetailsForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleDetailsForm"
                        :label-position="labelPosition"
                        class="details_temp2023"
                    >
                        <el-form-item label="code：" prop="code">
                            <el-input :disabled="type == 1" size="mini" clearable v-model="ruleForm.code" placeholder="请输入代码" />
                        </el-form-item>
                        <el-form-item label="名称：" prop="name">
                            <el-input size="mini" v-model="ruleForm.name" clearable placeholder="请输入名称" />
                            <el-tooltip class="Tooltip" effect="dark" content="请填写真实名称，便于天眼查查询" placement="top-start">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="类型：" prop="type">
                            <el-select filterable v-model="ruleForm.type" placeholder="请选择类型" clearable size="mini" multiple>
                                <el-option v-for="item in typeOption" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="合作方名称：" prop="partner_rid">
                            <el-select
                                style="width: 100%"
                                v-model="ruleForm.partner_name"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="请输入合作方名称搜索"
                                :remote-method="remotePartnerMethod"
                                :loading="partnerLoading"
                                size="mini"
                                clearable
                                @change="partnerChange"
                            >
                                <el-option v-for="item in partnerOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="省份："
                            prop="province_rid"
                            :rules="{
                                required: editShow,
                                message: '省份不能为空',
                                trigger: 'blur'
                            }"
                        >
                            <el-select
                                v-model="ruleForm.province_rid"
                                clearable
                                @change="provinceChange"
                                filterable
                                size="mini"
                                placeholder="请选择省份"
                            >
                                <el-option v-for="item in provincesOptionsFrom" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="寰通编号：" prop="huantong_code">
                            <el-input size="mini" v-model="ruleForm.huantong_code" clearable placeholder="请输入寰通编号" />
                        </el-form-item>

                        <el-form-item
                            label="城市："
                            prop="city_rid"
                            :rules="{
                                required: editShow,
                                message: '城市不能为空',
                                trigger: 'blur'
                            }"
                        >
                            <el-select
                                v-model="ruleForm.city_rid"
                                clearable
                                filterable
                                size="mini"
                                placeholder="请选择城市"
                                @change="cityChange"
                            >
                                <el-option v-for="item in cityOptionsFrom" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="寰通名称：" prop="huantong_name">
                            <el-input size="mini" v-model="ruleForm.huantong_name" clearable placeholder="请输入寰通名称" />
                        </el-form-item>

                        <el-form-item label="区县：" prop="county_rid">
                            <el-select
                                v-model="ruleForm.county_rid"
                                clearable
                                filterable
                                size="mini"
                                placeholder="请选择区县"
                                @change="countyChange"
                            >
                                <el-option v-for="item in countyOptionsFrom" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="国家地区：" prop="country_region ">
                            <el-input size="mini" v-model="ruleForm.country_region" clearable placeholder="请输入国家地区" />
                        </el-form-item>
                        <el-form-item label="验证信息：" prop="verification_info">
                            <el-input size="mini" v-model="ruleForm.verification_info" clearable placeholder="请输入验证信息" />
                        </el-form-item>
                        <el-form-item label="纬度：" prop="longitude">
                            <el-input size="mini" v-model="ruleForm.latitude" clearable placeholder="请输入纬度" type="number" />
                            <el-tooltip class="Tooltip" effect="dark" content="填写地址后会自动获取纬度信息" placement="top-start">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="地址：" prop="address">
                            <el-input size="mini" v-model="ruleForm.address" clearable placeholder="请输入地址" />
                        </el-form-item>
                        <el-form-item label="经度：" prop="latitude">
                            <el-input
                                size="mini"
                                v-model="ruleForm.longitude"
                                clearable
                                placeholder="请输入经度"
                                type="number"
                                :step="0.1"
                            />
                            <el-tooltip class="Tooltip" effect="dark" content="填写地址后会自动获取经度信息" placement="top-start">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="是否校验名称：" prop="is_query">
                            <el-select filterable v-model="ruleForm.is_query" size="mini" placeholder="请选择是否校验名称">
                                <el-option clearable v-for="item in queryOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                            <el-tooltip
                                class="Tooltip"
                                effect="dark"
                                content="强制查询天眼查选项单次有效，身份类型为自然人该配置无效（不会查询天眼查）"
                                placement="top-start"
                            >
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="统一社会信用代码：" prop="social_credit_code">
                            <el-input clearable size="mini" v-model="ruleForm.social_credit_code" placeholder="请输入统一社会信用代码" />
                            <el-tooltip class="Tooltip" effect="dark" content="不填会去天眼查自动获取信息" placement="top-start">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </el-form-item>

                        <el-form-item label="确信度：" prop="confidence">
                            <vDropdown
                                model_key="confidence"
                                model_name="请选择确信度"
                                :model_value_default="ruleForm.confidence"
                                request_uri="accountConfidence"
                                select_value="value"
                                @onDropChange="onDropChange"
                                ref="confidence_ref"
                            ></vDropdown>
                            <el-tooltip class="Tooltip" effect="dark" content="不填默认为：非常不确定" placement="top-start">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </el-form-item>

                        <el-form-item label="身份类型：" prop="identity_type">
                            <vDropdown
                                model_key="identity_type"
                                model_name="请选择身份类型"
                                :model_value_default="ruleForm.identity_type"
                                request_uri="identityTypes"
                                select_value="value"
                                @onDropChange="onDropChange"
                                ref="identity_type_ref"
                            ></vDropdown>
                            <el-tooltip class="Tooltip" effect="dark" content="不填默认为法人" placement="top-start">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </el-form-item>

                        <el-form-item label="渠道类型：" prop="channel_type_code">
                            <vDropdown
                                model_key="channel_type_code"
                                model_name="请选择渠道类型"
                                :model_value_default="ruleForm.channel_type_code"
                                request_uri="dropChannelType"
                                select_value="value"
                                @onDropChange="onDropChange"
                                ref="channel_type_code_ref"
                            ></vDropdown>
                        </el-form-item>

                        <el-form-item label="备注：" prop="remark">
                            <el-input size="mini" v-model="ruleForm.remark" clearable placeholder="请输入备注" />
                        </el-form-item>

                        <el-form-item label="经营范围：" prop="business_scope">
                            <el-input size="mini" v-model="ruleForm.business_scope" clearable placeholder="请输入经营范围" />
                        </el-form-item>

                        <el-form-item label="创建人：" prop="created_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.created_by ? ruleForm.created_by : '' }}
                            </div>
                        </el-form-item>
                        <el-form-item label="上次修改人：" prop="updated_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.updated_by ? ruleForm.updated_by : '' }}
                            </div>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
export default {
    name: 'accountEdit',
    data() {
        return {
            editShow: true,
            btnLoading: false,
            disabled: false,
            rid: '',
            type: '', //区分是修改还是新增
            rowRid: '', //当前行的rid
            list: {},
            code: '',
            title: '',
            activeNames: ['1'],
            provincesOptionsFrom: [], //省份列表
            cityOptionsFrom: [], //城市列表
            countyOptionsFrom: [],
            queryOptions: [
                {
                    value: 1,
                    label: '名称变化时查询天眼查'
                },
                {
                    value: 2,
                    label: '不查询天眼查'
                },
                {
                    value: 3,
                    label: '强制查询天眼查'
                }
            ],
            labelPosition: 'right',
            //基本信息内表单验证
            ruleForm: {
                address: '',
                city_name: '',
                city_rid: '',
                county_name: '',
                county_rid: '',
                code: '',
                created_at: '',
                created_by: '',
                huantong_code: '',
                huantong_name: '',
                id: '',
                latitude: '',
                longitude: '',
                country_region: '',
                verification_info: '',
                name: '',
                partner_rid: '',
                partner_name: '',
                province_name: '',
                province_rid: '',
                rid: '',
                social_credit_code: '',
                type: [],
                updated_at: '',
                updated_by: '',
                is_query: '1',
                sf_code: '',
                remark: '',
                business_scope: '',
                identity_type: '',
                confidence: '',
                channel_type_code: ''
            },
            rules: {
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                province_rid: [{ required: true, message: '请选择省份', trigger: 'blur' }],
                city_rid: [{ required: true, message: '请选择城市', trigger: 'blur' }],
                // code: [{ required: true, message: '请输入代码', trigger: 'blur' }],
                type: [{ required: true, message: '请选择类型', trigger: 'blur' }]
            },
            categoryOption: [],
            typeOption: [], //不带全部类型
            total: 0,
            page: 1,
            row: 25,
            btnTitle: '',
            partnerLoading: false,
            partnerOptions: [] //合作方搜索列表
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.rid = this.$route.query.id;
    },
    mounted() {
        this.getCategory();
        this.getType();
        if (this.type == 1 || this.type == 5) {
            this.getDetails(); //获取详情
            this.editShow = true;
        } else if (this.type == 4) {
            this.editShow = true;
            this.ruleForm = {
                address: '',
                city_name: '',
                city_rid: '',
                county_name: '',
                county_rid: '',
                code: '',
                created_at: '',
                created_by: '',
                huantong_code: '',
                huantong_name: '',
                id: '',
                latitude: '',
                longitude: '',
                country_region: '',
                verification_info: '',
                name: '',
                partner_rid: '',
                partner_name: '',
                province_name: '',
                province_rid: '',
                rid: '',
                social_credit_code: '',
                type: this.$route.query.detail_type.split(','),
                updated_at: '',
                updated_by: '',
                is_query: 1,
                sf_code: '',
                remark: '',
                business_scope: '',
                identity_type: '',
                confidence: '',
                channel_type_code: ''
            };
            this.disabled = true;
            this.ruleForm.type = this.ruleForm.type.map(Number);
        } else {
            this.editShow = true;
            this.ruleForm = {
                address: '',
                city_name: '',
                city_rid: '',
                county_name: '',
                county_rid: '',
                code: '',
                created_at: '',
                created_by: '',
                huantong_code: '',
                huantong_name: '',
                id: '',
                latitude: '',
                longitude: '',
                country_region: '',
                verification_info: '',
                name: '',
                partner_rid: '',
                partner_name: '',
                province_name: '',
                province_rid: '',
                rid: '',
                social_credit_code: '',
                type: [],
                updated_at: '',
                updated_by: '',
                is_query: 1,
                sf_code: '',
                remark: '',
                business_scope: '',
                identity_type: '',
                confidence: '',
                channel_type_code: ''
            };
        }
        this.getProvinces(); //获取省份
    },
    methods: {
        //城市选择框联动
        cityChange(val) {
            // 填充城市RID，大部分场景没有区县的
            this.ruleForm.city_rid = val;

            // 更新区县下拉
            this.countyOptionsFrom = [];
            this.ruleForm.county_rid = '';

            if (val) {
                let params = {
                    parent_rid: val
                };
                this.$api
                    .districts(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.countyOptionsFrom = [];
                            let data = res.data;
                            data.forEach((value) => {
                                this.countyOptionsFrom.push({
                                    value: value.rid,
                                    label: value.name
                                });
                            });
                        }
                    })
                    .catch((error) => {});
            }
        },
        countyChange(val) {
            this.ruleForm.county_rid = val;
        },
        getCategory() {
            let params = {};
            this.$api
                .accountCategory(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.categoryOption = res.data;
                    }
                })
                .catch((error) => {});
        },
        //获取类型
        getType() {
            let params = {};
            this.$api
                .accountType(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.typeOption = res.data;
                    }
                })
                .catch((error) => {});
        },
        //合作方远程搜索方法
        remotePartnerMethod(query) {
            if (query !== '') {
                this.partnerLoading = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchPartners(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.partnerLoading = false;
                            this.partnerOptions = res.data;
                        } else {
                            this.partnerOptions = [];
                        }
                    })
                    .catch((error) => {});
            } else {
                this.partnerLoading = false;
                this.partnerOptions = [];
            }
        },
        onDropChange(key, value) {
            this.ruleForm[key] = value;
        },
        //获取省份
        getProvinces() {
            let params = {
                has_all: '0'
            };
            this.$api
                .provinces(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.provincesOptionsFrom = [];
                        let data = res.data;
                        data.forEach((value) => {
                            this.provincesOptionsFrom.push({
                                value: value.rid,
                                label: value.name
                            });
                        });
                    }
                })
                .catch((error) => {});
        },
        getCities() {
            let params = {
                parent_rid: this.ruleForm.province_rid
            };
            this.$api
                .cities(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.cityOptionsFrom = [];
                        let data = res.data;
                        data.forEach((value) => {
                            this.cityOptionsFrom.push({
                                value: value.rid,
                                label: value.name
                            });
                        });
                    }
                })
                .catch((error) => {});
        },
        getCounties() {
            let params = {
                parent_rid: this.ruleForm.city_rid
            };
            this.$api
                .districts(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.countyOptionsFrom = [];
                        let data = res.data;
                        data.forEach((value) => {
                            this.countyOptionsFrom.push({
                                value: value.rid,
                                label: value.name
                            });
                        });
                    }
                })
                .catch((error) => {});
        },
        //表单内选择省份 出下面的城市
        provinceChange(val) {
            this.cityOptionsFrom = [];
            this.countyOptionsFrom = [];
            this.ruleForm.city_rid = '';
            this.ruleForm.county_rid = '';

            if (val) {
                let params = {
                    parent_rid: val
                };
                this.$api
                    .cities(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.cityOptionsFrom = [];
                            let data = res.data;
                            data.forEach((value) => {
                                this.cityOptionsFrom.push({
                                    value: value.rid,
                                    label: value.name
                                });
                            });
                        }
                    })
                    .catch((error) => {});
            }
        },
        //合作方名称联动框改变
        partnerChange(value) {
            this.ruleForm.partner_rid = value;
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/account' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .accountDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.ruleForm = {
                            address: res.data.address,
                            city_name: res.data.city_name,
                            city_rid: res.data.city_rid,
                            county_name: res.data.county_name,
                            county_rid: res.data.county_rid,
                            code: res.data.code,
                            huantong_code: res.data.huantong_code,
                            huantong_name: res.data.huantong_name,
                            id: res.data.id,
                            latitude: res.data.latitude,
                            longitude: res.data.longitude,
                            country_region: res.data.country_region,
                            verification_info: res.data.verification_info,
                            name: res.data.name,
                            partner_rid: res.data.partner_rid,
                            partner_name: res.data.partner_name,
                            province_name: res.data.province_name,
                            province_rid: res.data.province_rid,
                            rid: res.data.rid,
                            social_credit_code: res.data.social_credit_code,
                            is_query: res.data.is_query,
                            created_at: res.data.created_at,
                            created_by: res.data.created_by,
                            updated_at: res.data.updated_at,
                            updated_by: res.data.updated_by,
                            type: res.data.type.split(','),
                            sf_code: res.data.sf_code,
                            remark: res.data.remark,
                            business_scope: res.data.business_scope,
                            identity_type: res.data.identity_type,
                            confidence: res.data.confidence,
                            channel_type_code: res.data.channel_type_code
                        };
                        this.ruleForm.type = this.ruleForm.type.map(Number);
                        this.getCities();
                        this.getCounties();
                    }
                })
                .catch((error) => {});
        },
        //提交基本信息修改
        submitDetailsData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.type == 1) {
                        this.submitEditData(); //修改
                    } else {
                        this.submitAddData(); //新增
                    }
                } else {
                    return false;
                }
            });
        },
        //提交基本信息新增
        submitAddData() {
            this.btnLoading = true;
            let params = {
                type: this.ruleForm.type,
                code: this.ruleForm.code,
                name: this.ruleForm.name,
                partner_rid: this.ruleForm.partner_rid ? this.ruleForm.partner_rid : '',
                city_rid: this.ruleForm.city_rid,
                county_rid: this.ruleForm.county_rid,
                social_credit_code: this.ruleForm.social_credit_code ? this.ruleForm.social_credit_code : '',
                huantong_code: this.ruleForm.huantong_code ? this.ruleForm.huantong_code : '',
                huantong_name: this.ruleForm.huantong_name ? this.ruleForm.huantong_name : '',
                address: this.ruleForm.address ? this.ruleForm.address : '',
                longitude: this.ruleForm.longitude ? this.ruleForm.longitude : '',
                country_region: this.ruleForm.country_region ? this.ruleForm.country_region : '',
                verification_info: this.ruleForm.verification_info ? this.ruleForm.verification_info : '',
                latitude: this.ruleForm.latitude ? this.ruleForm.latitude : '',
                is_query: this.ruleForm.is_query ? this.ruleForm.is_query : '',
                sf_code: this.ruleForm.sf_code,
                remark: this.ruleForm.remark,
                business_scope: this.ruleForm.business_scope,
                identity_type: this.ruleForm.identity_type,
                confidence: this.ruleForm.confidence,
                channel_type_code: this.ruleForm.channel_type_code
            };
            this.$api
                .accountInsert(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.btnLoading = false;
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.$router.push({
                            path: '/accountDetails',
                            query: {
                                id: res.data.rid
                            }
                        });
                    } else {
                        this.btnLoading = false;
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        },
        //提交基本信息修改
        submitEditData() {
            this.btnLoading = true;
            let params = {
                type: this.ruleForm.type,
                code: this.ruleForm.code,
                name: this.ruleForm.name,
                partner_rid: this.ruleForm.partner_rid ? this.ruleForm.partner_rid : '',
                city_rid: this.ruleForm.city_rid,
                county_rid: this.ruleForm.county_rid,
                social_credit_code: this.ruleForm.social_credit_code ? this.ruleForm.social_credit_code : '',
                huantong_code: this.ruleForm.huantong_code ? this.ruleForm.huantong_code : '',
                huantong_name: this.ruleForm.huantong_name ? this.ruleForm.huantong_name : '',
                address: this.ruleForm.address ? this.ruleForm.address : '',
                longitude: this.ruleForm.longitude ? this.ruleForm.longitude : '',
                country_region: this.ruleForm.country_region ? this.ruleForm.country_region : '',
                verification_info: this.ruleForm.verification_info ? this.ruleForm.verification_info : '',
                latitude: this.ruleForm.latitude ? this.ruleForm.latitude : '',
                is_query: this.ruleForm.is_query ? this.ruleForm.is_query : '',
                rid: this.rid,
                sf_code: this.ruleForm.sf_code,
                remark: this.ruleForm.remark,
                business_scope: this.ruleForm.business_scope,
                identity_type: this.ruleForm.identity_type,
                confidence: this.ruleForm.confidence,
                channel_type_code: this.ruleForm.channel_type_code
            };
            this.$api
                .accountUpdate(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.btnLoading = false;
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.cancel();
                    } else {
                        this.btnLoading = false;
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>